
import Axios from "./CallerService"
export const getProducts = (id) => {
    return Axios.get(`products/${id}/purchase_prices`)
}
